import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  JOBDRPDATA,
  PROVINCEDRPDATA,
  PLANLINKDRPDATA,
} from "../../../App.config";
import CustomDatePicker from "../../../containers/Common/CustomDatePicker";
import DropdownComponent from "../../../containers/Dropdown";

const EmploymentInformation = ({
  state,
  onDateChange,
  handleChanges,
  onDropDownChange,
  previousStep,
  onSubmit,
}) => {
  return (
    <>
      <div className="Dashboard-Content">
        <div className="Inner-cell">
          <div className="Panel-cell">
            <div className="Panel-header">
              {/* <div className="p-img">
                <img src={Compensation} alt="" />
              </div> */}
              <h2>
                <span>Company Information</span>
              </h2>
              {/* <legend>EMPLOYER INFORMATION</legend> */}
            </div>
            <div className="panel-content">
              <div className="Custom-form">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">External ID:</label>
                      <input
                        type="text"
                        className="form-control"
                        name="externalId"
                        value={state.externalId.value}
                        onChange={handleChanges}
                      />
                      {state.externalId?.error && (
                        <span className="error">{state.externalId.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group  Date-feild">
                      <label htmlFor="">Date of Hire:</label>
                      <CustomDatePicker
                        selected={state.dateofHire.value}
                        onChange={(e) => {
                          onDateChange(e, "dateofHire");
                        }}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        Manager Language Preference:
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <ul>
                        <li className="Radio-box">
                          <div className="check-col">
                            <input
                              type="radio"
                              tabIndex="-1"
                              id="By-Yes"
                              name="managerLanguagePreference"
                              value="English"
                              checked={
                                state.managerLanguagePreference.value ===
                                "English"
                              }
                              onChange={handleChanges}
                            />
                            <label htmlFor="By-Yes">English</label>
                          </div>
                          <div className="check-col">
                            <input
                              type="radio"
                              tabIndex="-1"
                              id="By-No"
                              name="managerLanguagePreference"
                              value="French"
                              checked={
                                state.managerLanguagePreference.value ===
                                "French"
                              }
                              onChange={handleChanges}
                            />
                            <label htmlFor="By-No">French</label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        Division/Location:
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <DropdownComponent
                        name="division"
                        options={PROVINCEDRPDATA}
                        isMultiSelect={false}
                        option_key="stateId"
                        option_display="stateName"
                        onChange={onDropDownChange}
                        values={state.division.value}
                        simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                        selectAllText="Select All Options"
                        isSearchOption={true}
                        searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                      />
                      {state.division?.error && (
                        <span className="error">{state.division.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        Job:
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <DropdownComponent
                        name="job"
                        options={JOBDRPDATA}
                        isMultiSelect={false}
                        option_key="jobId"
                        option_display="jobName"
                        onChange={onDropDownChange}
                        values={state.job.value}
                        simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                        selectAllText="Select All Options"
                        isSearchOption={true}
                        searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                      />
                      {state.job?.error && (
                        <span className="error">{state.job.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        LTD Plan Link:
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <DropdownComponent
                        name="ltdPlanLink"
                        options={PLANLINKDRPDATA}
                        isMultiSelect={false}
                        option_key="PlanLinkId"
                        option_display="planLinkName"
                        onChange={onDropDownChange}
                        values={state.ltdPlanLink.value}
                        simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                        selectAllText="Select All Options"
                        isSearchOption={true}
                        searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                      />
                      {state.ltdPlanLink?.error && (
                        <span className="error">{state.ltdPlanLink.error}</span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        File Contact:
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <DropdownComponent
                        name="fileContact"
                        options={PLANLINKDRPDATA}
                        isMultiSelect={false}
                        option_key="PlanLinkId"
                        option_display="planLinkName"
                        onChange={onDropDownChange}
                        values={state.fileContact.value}
                        simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                        selectAllText="Select All Options"
                        isSearchOption={true}
                        searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                      />
                      {state.fileContact?.error && (
                        <span className="error">{state.fileContact.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">File Contact Phone#</label>
                      <input
                        type="text"
                        className="form-control"
                        name="fileContactPhone"
                        readOnly
                        value={state.fileContactPhone.value}
                        onChange={handleChanges}
                      />
                      {state.fileContactPhone?.error && (
                        <span className="error">
                          {state.fileContactPhone.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">File Contact Email</label>
                      <input
                        type="text"
                        name="fileContactEmail"
                        readOnly
                        value={state.fileContactEmail.value}
                        onChange={handleChanges}
                        className="form-control"
                      />
                      {state.fileContactEmail?.error && (
                        <span className="error">
                          {state.fileContactEmail.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        Manager/Supervisor Name:
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <DropdownComponent
                        name="supervisor"
                        options={PLANLINKDRPDATA}
                        isMultiSelect={false}
                        option_key="PlanLinkId"
                        option_display="planLinkName"
                        onChange={onDropDownChange}
                        values={state.supervisor.value}
                        simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                        selectAllText="Select All Options"
                        isSearchOption={true}
                        searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                      />
                      {state.supervisor?.error && (
                        <span className="error">{state.supervisor.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">Manager/Supervisor Phone#</label>
                      <input
                        type="text"
                        className="form-control"
                        name="supervisorPhone"
                        readOnly
                        value={state.supervisorPhone.value}
                        onChange={handleChanges}
                      />
                      {state.supervisorPhone?.error && (
                        <span className="error">
                          {state.supervisorPhone.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">Manager/Supervisor Email</label>
                      <input
                        type="text"
                        name="supervisorEmail"
                        readOnly
                        value={state.supervisorEmail.value}
                        onChange={handleChanges}
                        className="form-control"
                      />
                      {state.supervisorEmail?.error && (
                        <span className="error">
                          {state.supervisorEmail.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        HRC Name:
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <DropdownComponent
                        name="hrc"
                        options={PLANLINKDRPDATA}
                        isMultiSelect={false}
                        option_key="PlanLinkId"
                        option_display="planLinkName"
                        onChange={onDropDownChange}
                        values={state.hrc.value}
                        simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                        selectAllText="Select All Options"
                        isSearchOption={true}
                        searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                      />
                      {state.hrc?.error && (
                        <span className="error">{state.hrc.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">HRC Phone#</label>
                      <input
                        type="text"
                        className="form-control"
                        name="hrcPhone"
                        readOnly
                        value={state.hrcPhone.value}
                        onChange={handleChanges}
                      />
                      {state.hrcPhone?.error && (
                        <span className="error">{state.hrcPhone.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">HRC Email</label>
                      <input
                        type="text"
                        name="hrcEmail"
                        readOnly
                        value={state.hrcEmail.value}
                        onChange={handleChanges}
                        className="form-control"
                      />
                      {state.hrcEmail?.error && (
                        <span className="error">{state.hrcEmail.error}</span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        ERC Name:
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <DropdownComponent
                        name="ercName"
                        options={PLANLINKDRPDATA}
                        isMultiSelect={false}
                        option_key="PlanLinkId"
                        option_display="planLinkName"
                        onChange={onDropDownChange}
                        values={state.ercName.value}
                        simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                        selectAllText="Select All Options"
                        isSearchOption={true}
                        searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                      />
                      {state.ercName?.error && (
                        <span className="error">{state.ercName.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">ERC Phone#</label>
                      <input
                        type="text"
                        className="form-control"
                        name="ercPhone"
                        readOnly
                        value={state.ercPhone.value}
                        onChange={handleChanges}
                      />
                      {state.ercPhone?.error && (
                        <span className="error">{state.ercPhone.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">ERC Email</label>
                      <input
                        type="text"
                        name="ercEmail"
                        readOnly
                        value={state.ercEmail.value}
                        onChange={handleChanges}
                        className="form-control"
                      />
                      {state.ercEmail?.error && (
                        <span className="error">{state.ercEmail.error}</span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">Additional Email Recipients</label>
                      <input
                        type="text"
                        name="additionalEmailRecipients"
                        value={state.additionalEmailRecipients.value}
                        onChange={handleChanges}
                        className="form-control"
                      />
                      {state.additionalEmailRecipients?.error && (
                        <span className="error">
                          {state.additionalEmailRecipients.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="panel-footer margn-50">
                      <a
                        tabIndex="0"
                        onClick={previousStep}
                        className="btn btn-primary"
                      >
                        Previous
                      </a>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="panel-footer text-right margn-50">
                      <a
                        tabIndex="0"
                        onClick={onSubmit}
                        className="btn btn-primary"
                      >
                        Save and Move to Next Step
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmploymentInformation;
